import React from 'react';
import FormHeader from '../Item/FormHeader';
import InputAreaControlled from '../ui/InputAreaControlled';
import InputCheckNumberCustomControlled from '../ui/InputCheckNumberCustomControlled';
import InputCheckCustomControlled from '../ui/InputCheckCustomControlled';

const MachineryFormFields = () => {
  return (
    <div>
      <div className="container-border p-4">
        <FormHeader />
      </div>
      <div className="mt-2 container-border p-4">
        <h3>Inspección de Carroceria</h3>
        <div className="mb-2">
          <InputCheckNumberCustomControlled
            name={`bodyinspection.parabrisas`}
            section="car_inspection"
          />
        </div>
        <div className="mb-2">
          <InputCheckNumberCustomControlled
            name={`bodyinspection.vidriolat`}
            section="car_inspection"
          />
        </div>
        <div className="mb-2">
          <InputCheckNumberCustomControlled
            name={`bodyinspection.vidriotra`}
            section="car_inspection"
          />
        </div>
        <div className="mb-2">
          <InputCheckNumberCustomControlled
            name={`bodyinspection.tapiz`}
            section="car_inspection"
          />
        </div>
        <div className="mb-2">
          <InputCheckNumberCustomControlled
            name={`bodyinspection.tablero`}
            section="car_inspection"
          />
        </div>
        <div className="mb-2">
          <InputCheckNumberCustomControlled
            name={`bodyinspection.puertas`}
            section="car_inspection"
          />
        </div>
        <div className="mb-2">
          <InputCheckNumberCustomControlled
            name={`bodyinspection.techo`}
            section="car_inspection"
          />
        </div>
        <div className="mb-2">
          <InputCheckNumberCustomControlled
            name={`bodyinspection.parachoques`}
            section="car_inspection"
          />
        </div>
        <div className="mb-2">
          <InputCheckNumberCustomControlled
            name={`bodyinspection.mascara`}
            section="car_inspection"
          />
        </div>
        <div className="mb-2">
          <InputCheckNumberCustomControlled
            name={`bodyinspection.capot`}
            section="car_inspection"
          />
        </div>
        <div className="mb-2">
          <InputCheckNumberCustomControlled
            name={`bodyinspection.tapamaleta`}
            section="car_inspection"
          />
        </div>
        <div className="mb-2">
          <InputCheckNumberCustomControlled
            name={`bodyinspection.tapabarros`}
            section="car_inspection"
          />
        </div>
        <div className="mb-2">
          <InputCheckNumberCustomControlled
            name={`bodyinspection.alzavidrioElectrico`}
            section="car_inspection"
          />
        </div>
        <div className="mb-2">
          <InputCheckNumberCustomControlled
            name={`bodyinspection.otros`}
            section="car_inspection"
          />
        </div>
      </div>
      <div className="mt-2 container-border p-4">
        <h3>Accesorios e Inventario</h3>
        <div className="mb-2">
          <InputCheckNumberCustomControlled
            name={`accesoriesInventory.llaves`}
            section="accesories_inventory"
          />
        </div>
        <div className="mb-2">
          <InputCheckNumberCustomControlled
            name={`accesoriesInventory.triangulos`}
            section="accesories_inventory"
          />
        </div>
        <div className="mb-2">
          <InputCheckNumberCustomControlled
            name={`accesoriesInventory.gata`}
            section="accesories_inventory"
          />
        </div>
        <div className="mb-2">
          <InputCheckNumberCustomControlled
            name={`accesoriesInventory.llaveRuedas`}
            section="accesories_inventory"
          />
        </div>
        <div className="mb-2">
          <InputCheckNumberCustomControlled
            name={`accesoriesInventory.herramientas`}
            section="accesories_inventory"
          />
        </div>
        <div className="mb-2">
          <InputCheckNumberCustomControlled
            name={`accesoriesInventory.extintor`}
            section="accesories_inventory"
          />
        </div>
        <div className="mb-2">
          <InputCheckNumberCustomControlled
            name={`accesoriesInventory.botiquin`}
            section="accesories_inventory"
          />
        </div>
        <div className="mb-2">
          <InputCheckNumberCustomControlled
            name={`accesoriesInventory.encendedor`}
            section="accesories_inventory"
          />
        </div>
        <div className="mb-2">
          <InputCheckNumberCustomControlled
            name={`accesoriesInventory.antena`}
            section="accesories_inventory"
          />
        </div>
        <div className="mb-2">
          <InputCheckNumberCustomControlled
            name={`accesoriesInventory.parrilla`}
            section="accesories_inventory"
          />
        </div>
        <div className="mb-2">
          <InputCheckNumberCustomControlled
            name={`accesoriesInventory.viseras`}
            section="accesories_inventory"
          />
        </div>
        <div className="mb-2">
          <InputCheckNumberCustomControlled
            name={`accesoriesInventory.cinturones`}
            section="accesories_inventory"
          />
        </div>
        <div className="mb-2">
          <InputCheckNumberCustomControlled
            name={`accesoriesInventory.pisos`}
            section="accesories_inventory"
          />
        </div>
        <div className="mb-2">
          <InputCheckNumberCustomControlled
            name={`accesoriesInventory.neblineros`}
            section="accesories_inventory"
          />
        </div>
        <div className="mb-2">
          <InputCheckNumberCustomControlled
            name={`accesoriesInventory.espejo`}
            section="accesories_inventory"
          />
        </div>
        <div className="mb-2">
          <InputCheckNumberCustomControlled
            name={`accesoriesInventory.cenicero`}
            section="accesories_inventory"
          />
        </div>
        <div className="mb-2">
          <InputCheckNumberCustomControlled
            name={`accesoriesInventory.radio`}
            section="accesories_inventory"
          />
        </div>
        <div className="mb-2">
          <InputCheckNumberCustomControlled
            name={`accesoriesInventory.parlantes`}
            section="accesories_inventory"
          />
        </div>
        <div className="mb-2">
          <InputCheckNumberCustomControlled
            name={`accesoriesInventory.tapasEst`}
            section="accesories_inventory"
          />
        </div>
        <div className="mb-2">
          <InputCheckNumberCustomControlled
            name={`accesoriesInventory.ac`}
            section="accesories_inventory"
          />
        </div>
        <div className="mb-2">
          <InputCheckNumberCustomControlled
            name={`accesoriesInventory.dirH`}
            section="accesories_inventory"
          />
        </div>
        <div className="mb-2">
          <InputCheckNumberCustomControlled
            name={`accesoriesInventory.tapasRuedas`}
            section="accesories_inventory"
          />
        </div>
        <div className="mb-2">
          <InputCheckNumberCustomControlled
            name={`accesoriesInventory.plumillas`}
            section="accesories_inventory"
          />
        </div>
        <div className="mb-2">
          <InputCheckNumberCustomControlled
            name={`accesoriesInventory.llantas`}
            section="accesories_inventory"
          />
        </div>
        <div className="mb-2">
          <InputCheckNumberCustomControlled
            name={`accesoriesInventory.neumaticos`}
            section="accesories_inventory"
          />
        </div>
        <div className="mb-2">
          <InputCheckNumberCustomControlled
            name={`accesoriesInventory.neumaticosRepuesto`}
            section="accesories_inventory"
          />
        </div>
        <div className="mb-2">
          <InputCheckNumberCustomControlled
            name={`accesoriesInventory.tercerEje`}
            section="accesories_inventory"
          />
        </div>
        <div className="mb-2">
          <InputCheckNumberCustomControlled
            name={`accesoriesInventory.quintaRueda`}
            section="accesories_inventory"
          />
        </div>
        <div className="mb-2">
          <InputCheckNumberCustomControlled
            name={`accesoriesInventory.bateria`}
            section="accesories_inventory"
          />
        </div>
        <div className="mb-2">
          <InputCheckNumberCustomControlled
            name={`accesoriesInventory.tapasVarillas`}
            section="accesories_inventory"
          />
        </div>
        <div className="mb-2">
          <InputCheckNumberCustomControlled
            name={`accesoriesInventory.espejosExt`}
            section="accesories_inventory"
          />
        </div>
        <div className="mb-2">
          <InputCheckNumberCustomControlled
            name={`accesoriesInventory.focosDelanteros`}
            section="accesories_inventory"
          />
        </div>
        <div className="mb-2">
          <InputCheckNumberCustomControlled
            name={`accesoriesInventory.focosTraseros`}
            section="accesories_inventory"
          />
        </div>
        <div className="mb-2">
          <InputCheckNumberCustomControlled
            name={`accesoriesInventory.mandoAlVolante`}
            section="accesories_inventory"
          />
        </div>
        <div className="mb-2">
          <InputCheckNumberCustomControlled
            name={`accesoriesInventory.velocidadCrucero`}
            section="accesories_inventory"
          />
        </div>
        <div className="mb-2">
          <InputCheckNumberCustomControlled
            name={`accesoriesInventory.asientoElectricos`}
            section="accesories_inventory"
          />
        </div>
        <div className="mb-2">
          <InputCheckNumberCustomControlled
            name={`accesoriesInventory.usb`}
            section="accesories_inventory"
          />
        </div>
        <div className="mb-2">
          <InputCheckNumberCustomControlled
            name={`accesoriesInventory.usbC`}
            section="accesories_inventory"
          />
        </div>
        <div className="mb-2">
          <InputCheckNumberCustomControlled
            name={`accesoriesInventory.otros`}
            section="accesories_inventory"
          />
        </div>
      </div>
      <div className="mt-2 container-border p-4">
        <h3>Estado Mecánico</h3>
        <div className="mb-2">
          <InputCheckCustomControlled
            name={`mecanicState.brazos`}
            section="mechanic_state"
          />
        </div>
        <div className="mb-2">
          <InputCheckCustomControlled
            name={`mecanicState.cajaCambios`}
            section="mechanic_state"
          />
        </div>
        <div className="mb-2">
          <InputCheckCustomControlled
            name={`mecanicState.carroceria`}
            section="mechanic_state"
          />
        </div>
        <div className="mb-2">
          <InputCheckCustomControlled
            name={`mecanicState.cilindrada`}
            section="mechanic_state"
          />
        </div>
        <div className="mb-2">
          <InputCheckCustomControlled
            name={`mecanicState.combustible`}
            section="mechanic_state"
          />
        </div>
        <div className="mb-2">
          <InputCheckCustomControlled
            name={`mecanicState.funciona`}
            section="mechanic_state"
          />
        </div>
        <div className="mb-2">
          <InputCheckCustomControlled
            name={`mecanicState.motor`}
            section="mechanic_state"
          />
        </div>
        <div className="mb-2">
          <InputCheckCustomControlled
            name={`mecanicState.neumaticos`}
            section="mechanic_state"
          />
        </div>
        <div className="mb-2">
          <InputCheckCustomControlled
            name={`mecanicState.sistemaElectrico`}
            section="mechanic_state"
          />
        </div>
        <div className="mb-2">
          <InputCheckCustomControlled
            name={`mecanicState.sistemaHidraulico`}
            section="mechanic_state"
          />
        </div>
        <div className="mb-2">
          <InputCheckCustomControlled
            name={`mecanicState.tipoCombustible`}
            section="mechanic_state"
          />
        </div>
        <div className="mb-2">
          <InputCheckCustomControlled
            name={`mecanicState.tipoTransmision`}
            section="mechanic_state"
          />
        </div>
        <div className="mb-2">
          <InputCheckCustomControlled
            name={`mecanicState.transmision`}
            section="mechanic_state"
          />
        </div>
        <div className="mb-2">
          <InputCheckCustomControlled
            name={`mecanicState.traccion`}
            section="mechanic_state"
          />
        </div>
        <div className="mb-2">
          <InputCheckCustomControlled
            name={`mecanicState.otros`}
            section="mechanic_state"
          />
        </div>
      </div>
      <div className="container-border p-4 mt-2">
        <h3>Seguridad</h3>
        <div className="mb-2">
          <InputCheckNumberCustomControlled
            name={`safetyness.cierreCentralizado`}
            section="security"
          />
        </div>
        <div className="mb-2">
          <InputCheckNumberCustomControlled
            name={`safetyness.sensores`}
            section="security"
          />
        </div>
        <div className="mb-2">
          <InputCheckNumberCustomControlled
            name={`safetyness.airbag`}
            section="security"
          />
        </div>
        <div className="mb-2">
          <InputCheckNumberCustomControlled
            name={`safetyness.alarma`}
            section="security"
          />
        </div>
        <div className="mb-2">
          <InputCheckNumberCustomControlled
            name={`safetyness.alarmaRetroceso`}
            section="security"
          />
        </div>
        <div className="mb-2">
          <InputCheckNumberCustomControlled
            name={`safetyness.camaraRetroceso`}
            section="security"
          />
        </div>
        <div className="mb-2">
          <InputCheckNumberCustomControlled
            name={`safetyness.controlEstabilidad`}
            section="security"
          />
        </div>
      </div>
      <div className="container-border p-4 mt-2">
        <h3>Observaciones Generales</h3>
        <InputAreaControlled name="comments" />
      </div>
    </div>
  );
};

export default MachineryFormFields;
